import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as promotionActions from './../../../../actions/promotionAction';
import AppUI from "./AppUI";
import { deleteAppUIConfig } from "actions/appUIAction";


const mapStateToProps = state => {
    return {
        appUIState: state.appUIReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteAppUIConfig: (id) => dispatch(deleteAppUIConfig(id))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AppUI));
